import MappingEditor from 'components/MappingEditor/MappingEditor';
import { MappingContext } from 'contexts/MappingContext';
import { EDITOR_PATH_ID } from 'contracts/constants';
import MappingContextLoader from 'pages/packages/package/mapping/MappingContextLoader';
import type { FC } from 'react';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { getParams } from 'utils';

interface MappingEditorContainerProps {}
const MappingEditorContainer: FC<MappingEditorContainerProps> = () => {
  const ctx = useContext(MappingContext);
  const { pathname } = useLocation();
  const params: any = getParams(pathname, [EDITOR_PATH_ID]);

  return (
    <MappingContextLoader entityId={params.entityId} versionUuid={params.versionUuid}>
      <MappingEditor key={params.entityId} />
    </MappingContextLoader>
  );
};

export default MappingEditorContainer;
